export type PosterCopyField = 'greeting' | 'projectTitle';

/** 本地模拟单字段确认；不调用接口、不持久化，也不修改已生成的海报。 */
export function savePosterCopy(_field: PosterCopyField, _value: string, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
    const abort = () => {
      clearTimeout(timer);
      signal.removeEventListener('abort', abort);
      reject(new DOMException('Aborted', 'AbortError'));
    };
    const timer = setTimeout(() => {
      signal.removeEventListener('abort', abort);
      resolve();
    }, 300);
    signal.addEventListener('abort', abort, { once: true });
  });
}
